'use client';

import { ReactNode } from 'react';
import { HttpTypes } from "@medusajs/types";
import { DynamicHeader } from './dynamic-header';
import { DebugPanel } from '../../../../components/DebugPanel';

interface DynamicHeaderWrapperProps {
  regions: HttpTypes.StoreRegion[];
  collections: HttpTypes.StoreCollection[];
  categories: HttpTypes.StoreProductCategory[];
  cartButton: ReactNode;
}

export function DynamicHeaderWrapper({ regions, collections, categories, cartButton }: DynamicHeaderWrapperProps) {
  return (
    <>
      <DynamicHeader
        regions={regions}
        collections={collections}
        categories={categories}
        cartButton={cartButton}
      />
      <DebugPanel />
    </>
  );
}
